module.exports = __webpack_public_path__ + "img/onlineToolsImg4.82a9e772.png";